<!-- <title>Invoice</title> -->
<style>
  body {
    font-family: Arial, sans-serif;
    margin: 40px;
    background: #fff;
  }

  .invoice-container {
    border: 2px solid var(--green-900);
    padding: 40px;
    max-width: 800px;
    margin: auto;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    color: var(--green-700);
    font-family: ABC Arizona Flare;
    font-weight: 300;

    .invoice-number {
      font-size: 20px;
      font-weight: 400;
    }
  }

  h1 {
    margin: 0 0 10px 0;
  }

  .merchant-info-box {
    border: 1px solid var(--green-700);
    padding: 20px 40px;
    text-align: center;
    font-size: 15px;
    color: var(--green-900);
    background-color: var(--green-100);
  }

  .bill-section {
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: Booton;

    .bill-to {
      font-size: 13px;
      font-weight: 300;
    }

    .customer-email {
      text-decoration: underline;
      text-underline-offset: 2px;
    }
  }

  .invoice-meta {
    font-size: 16px;
  }

  .due {
    color: var(--green-700);
    font-size: 16px;
    font-weight: 650;
  }

  table {
    margin-top: 10px;
    width: 100%;
    border-spacing: 0;
    border: 1px solid var(--gray-200);

    .table-header-row {
      background-color: var(--table-header-gray);
      height: 48px;
      th {
        font-family: Booton;
          font-size: 13px;
          font-weight: 500;
          color: var(--gray-900);
          padding: 0 16px;
          text-align: left;
          cursor: pointer;
          white-space: nowrap;
          border-bottom: 1px solid var(--gray-200);
      }
    }

    .table-row {
      background-color: var(--white);
      td {
        font-family: Booton;
        font-size: 13px;
        color: var(--gray-900);
        padding: 8px 16px;
        border-bottom: none;
        box-shadow: inset 0 -1px 0 0 var(--gray-200);
      }
    }
  }

  .totals {
    margin-top: 50px;
    text-align: right;
    font-size: 16px;
    font-family: Booton;
  }

  .totals div {
    margin-bottom: 5px;
  }

  .grand-total {
    border-top: 1px solid var(--green-800);
    font-size: 20px;
    font-weight: bold;
    text-align: right;
    margin-top: 20px;
    padding-top: 20px;
  }

  .invoice-info {
    margin-top: 10px;
    font-size: 16px;
    font-weight: 400;
    color: var(--green-900);
  }
</style>

<div class="invoice-container" style="margin-top: 20px;">
  <div class="header">
    <div>
      <span class="invoice-number">INVOICE #{{ payableInvoice.number }}</span>
      <div class="invoice-info">
        <span>{{ currentDate }}</span>
      </div>
    </div>

    <div class="merchant-info-box">
      <strong>{{ payableInvoice.DBA }}</strong
      ><br />
      {{ payableInvoice.merchantEmail }}<br />
      {{ payableInvoice.merchantPhone }}
    </div>
  </div>

  <br/><br/>

  <div class="bill-section">
    <div>
      <span class="bill-to">bill to:</span><br />
      <span>{{ payableInvoice.firstName }} {{ payableInvoice.lastName }}</span
      ><br />
      <span class="customer-email">{{ payableInvoice.customerEmail }}</span><br />
    </div>
    @if (!invoicePaid) {
      <div class="due">DUE: {{ payableInvoice.dueDate.toLocaleDateString('en-US', {timeZone: 'UTC'}) }}</div>
    }
    @if (invoicePaid) {
      <div class="due">PAID IN FULL</div>
    }
  </div>

  <br/>

  <br/>

  @if (totalDueToday != 0) {
    <div style="background-color: var(--green-100); padding: 10px; margin-bottom: 10px;">
      <app-radio-group [options]="paymentTypeOptions" [(ngModel)]="selectedMode" (ngModelChange)="handlePaymentTypeChanged()"></app-radio-group>
    </div>
    @if (selectedMode) {
      <div style="background-color: var(--green-100); padding: 10px;">
        <app-terminal-billing-form
          [achEnabled]="achEnabled"
          [inlineMode]="true"
          [merchantId]="payableInvoice.merchantId"
          [customerId]="payableInvoice.customerId"
          [selectedPaymentType]="selectedMode"
          (onSelectedPaymentMethod)="handleSelectedPaymentMethodChanged($event)"
          (onValidationChange)="handleTokenizeFormValidationChanged($event)"
          (onTokenized)="handleTokenized($event)"
        ></app-terminal-billing-form>
      </div>
    }
  }

  <br/>

  <table>
    <tr class="table-header-row">
      <th>Item</th>
      <th>QTY</th>
      <th>Price</th>
      <th>Total</th>
    </tr>
    @for (item of payableInvoice.invoiceItems; track item) {
      <tr class="table-row">
        <td>{{ item.name }}</td>
        <td>{{ item.quantity }}</td>
        <td>
          {{
            uiHelpers.formatCurrencyToString(
              uiHelpers.demagnifyAmount(item.unitPrice, 100)
            )
          }}
        </td>
        <td>
          {{
            uiHelpers.formatCurrencyToString(
              uiHelpers.demagnifyAmount(item.unitPrice * item.quantity, 100)
            )
          }}
        </td>
      </tr>
    }
  </table>

  <div class="totals">
    <div>
      Sub-total: {{uiHelpers.formatCurrencyToString(uiHelpers.demagnifyAmount(payableInvoice.totalAmtDue - payableInvoice.taxMagnified,100))}}
    </div>
    <div>
      Tax: {{uiHelpers.formatCurrencyToString(uiHelpers.demagnifyAmount(payableInvoice.taxMagnified, 100))}}
    </div>
    <div>
      Total: {{uiHelpers.formatCurrencyToString(uiHelpers.demagnifyAmount(payableInvoice.totalAmtDue, 100))}}
    </div>
    @if (payableInvoice.isInstallment) {
      <div>
        Remaining Payments: {{ payableInvoice.remainingPayments }}
      </div>
    }
  </div>

  <div class="grand-total" *ngIf="totalDueToday > 0">
    Total Due: {{ uiHelpers.formatCurrencyToString(totalDueToday) }}
  </div>

  <div class="grand-total" *ngIf="totalDueToday == 0">
    Invoice has been paid in full.
  </div>

  <br/>

  <div
    style="
      display: flex;
      gap: 10px;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
    "
  >
    <input
      type="button"
      value="Submit Payment"
      class="btn-primary"
      (click)="handleSubmitPaymnetClicked()"
      [disabled]="formIsBeingSubmitted || payableInvoice.remainingPayments == 0 || !formValidated"
    />
  </div>
</div>
